<template>
  <hic-dialog append-to-body :close-on-click-modal="false" :visible="visible" title="模板编辑" @close="close" @open="open" fullscreen>
    <el-container>
      <el-header style="height:6.5rem">
        <el-form v-loading="meta.loading" ref="from" :model="entitie" label-width="9rem" :rules="rules">
          <el-row style="display: flex; flex-wrap: wrap">
            <el-col :span="8">
              <el-form-item label="模板名称：" prop="title">
                <el-input class="" v-model="entitie.title" maxlength="500" placeholder="" size="small" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="关键字：" prop="">
                <el-input class="" v-model="entitie.keyword" maxlength="500" placeholder="" size="small" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="模板范围：" prop="scope">
                <el-radio-group v-model="entitie.scope">
                  <el-radio label="本人">本人</el-radio>
                  <el-radio label="本科">本科</el-radio>
                  <el-radio label="全院">全院</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="备注：" prop="memo">
                <el-input class="" v-model="entitie.memo" maxlength="500" placeholder="" size="small" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-header>
      <el-main>
        <hic-table :entities="entity" :loading="meta.loading" hide-footer>
          <el-table-column align="center" width="10"><!--这列用颜色标记组数据--></el-table-column>
          <el-table-column :filters="dictEnum.AdviceType" :filter-multiple="false" column-key="type" align="center" width="100" label="类型" prop="type">
            <template slot-scope="{ row }">
              <el-select v-if="!row.id" :disabled="!!row.name" v-model="row.type" @change="clearOption" size="small">
                <el-option label="自动" value="自动" />
                <el-option label="药品" value="药品" />
                <el-option label="医技" value="医技" />
                <el-option label="嘱托" value="嘱托" />
              </el-select>
              <div v-else>
                <el-tag v-if="row.type == '药品'" type="primary" size="mini" hit effect="plain">{{ row.type }}</el-tag>
                <el-tag v-else-if="row.type == '草药'" type="warning" size="mini" hit effect="plain">{{ row.type }}</el-tag>
                <el-tag v-else-if="row.type == '医技'" type="danger" size="mini" hit effect="plain">{{ row.type }}</el-tag>
                <el-tag v-else-if="row.type == '嘱托'" type="info" hit size="small">{{ row.type }}</el-tag>
                <el-tag v-else type="danger" effect="light" hit size="small">{{ row.type }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column :filters="dictEnum.AdviceTerm" :filter-multiple="false" column-key="term" align="center" width="100" label="期效" prop="term">
            <template #default="{ row }">
              <hic-dict-selector v-if="isEdit(row) && row.type != '离院' && row.type != '转科'" dict-type="AdviceTerm" is-enum v-model="row.term" />
              <div v-else>
                <el-tag v-if="row.term == '长期'" type="success" size="mini" hit>{{ row.term }}</el-tag>
                <el-tag v-else-if="row.term == '临时'" type="danger" size="mini" hit>{{ row.term }}</el-tag>
                <el-tag v-else type="warning" size="mini" hit>{{ row.term }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="" min-width="600" label="医嘱内容" prop="name">
            <template #default="{ row }">
              <template v-if="row.name">
                <editorDrug v-if="row.type == '药品'" :row="row" :isEdit="!row.id" :readonly="row.state !== '草稿' && row.state !== '退回'" @saveAdvice="partSave" @addnew="adviceSave" @groupAdd="grpAddChild"> </editorDrug>
                <editorMl v-else-if="row.type == '医技'" :row="row" :isEdit="!row.id" :readonly="row.state !== '草稿' && row.state !== '退回'" @saveAdvice="partSave" @addnew="adviceSave" @groupAdd="grpAddChild"> </editorMl>
                <editorHerbal v-else-if="row.type == '草药'" :row="row" :readonly="row.state !== '草稿' && row.state !== '退回'" @init="page"></editorHerbal>
                <el-input v-else-if="row.type == '嘱托' && isEdit(row)" class="" v-model="row.name" maxlength="500" placeholder="请输入" size="small" clearable @change="partSave(row, { id: row.id, name: row.name })"></el-input>
                <div v-else-if="row.type == '转科' || row.type == '离院'">
                  <el-tag type="danger" hit style="border-left: 3rem solid #ff4949">
                    <span style="margin-left: -3rem; color: white">{{ row.type }}</span>
                    <span style="margin-left: 1.5rem">{{ row.content }}</span>
                  </el-tag>
                </div>
                <b v-else>{{ row.name }}</b>
              </template>
              <el-input v-else-if="row.type == '嘱托'" v-model="row.name" maxlength="500" placeholder="请输入" size="small" clearable @change="adviceSave(row)"></el-input>
              <el-select
                v-else
                ref="draftInput"
                allow-create
                :popper-append-to-body="false"
                @change="(val) => optionSelected(val, row)"
                style="width: 100%"
                size="small"
                v-model="options.selected"
                filterable
                placeholder="请选择"
                remote
                :filter-method="optionSearch"
                value-key="code"
                default-first-option
              >
                <!-- <el-option value="" disabled>
                <el-row style="width: 50rem; font-size: 15px" :gutter="16">
                  <el-col :span="4">名称</el-col>
                  <el-col :span="3">规格</el-col>
                  <el-col :span="3" class="right">单价</el-col>
                  <el-col :span="3" class="right">数量</el-col>
                  <el-col :span="2" class="center">单位</el-col>
                  <el-col :span="4">厂商</el-col>
                  <el-col :span="5" class="center">类别</el-col>
                </el-row>
              </el-option> -->
                <el-option v-for="item in options.drug" :key="item.id" :label="item.name" :value="item" style="font-size: 1rem; width: 50rem">
                  <el-row :gutter="0" :title="`厂商：${item.manufacturerCode} 批次：${item.lotNumber || '无'} 有效期：${item.expirationDate}`">
                    <el-col :span="1"><small class="primary">药品</small></el-col>
                    <el-col :span="14" style="white-space: pre-line">
                      <span>{{ item.name }}</span>
                      <small>{{ item.standard }}</small>
                    </el-col>
                    <el-col :span="4" class="right danger">￥{{ item.price | fmtFloat }}</el-col>
                    <el-col :span="3" class="left">
                      <span class="left-pad">{{ item.type | dictText("DrugType") }}</span>
                    </el-col>
                    <el-col :span="2" class="right primary">{{ item.quantity }} {{ item.unit }}</el-col>
                  </el-row>
                </el-option>
                <!-- <el-option value="" disabled>
                <el-row style="width: 50rem; font-size: 15px" :gutter="16">
                  <el-col :span="4">类型</el-col>
                  <el-col :span="4">名称</el-col>
                  <el-col :span="3">医保类别</el-col>
                  <el-col :span="3" class="right">价格（元）</el-col>
                </el-row>
              </el-option> -->
                <el-option v-for="item in options.ml" :key="item.id" :label="item.name" :value="item" style="font-size: 1rem; width: 50rem">
                  <el-row :gutter="0" :title="item.standard">
                    <el-col :span="1"><small class="warning">医技</small></el-col>
                    <el-col :span="14" style="white-space: pre-line">{{ item.name }}</el-col>
                    <el-col :span="4" class="right danger">￥{{ item.price | fmtFloat }}</el-col>
                    <el-col :span="3" class="left left-pad">{{ item.type | dictText("DrugType") }}</el-col>
                    <el-col :span="2" class="center">{{ item.insuranceClass | dictText("ReimbursCategory") }}</el-col>
                  </el-row>
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :filters="dictEnum.InsuranceRange" :filter-multiple="false" column-key="claimType" align="center" width="120" label="医保范围" prop="claimType">
            <template #default="{ row }">
              <hic-dict-selector v-if="isEdit(row)" dict-type="InsuranceRange" is-enum v-model="row.claimType" auto />
              <div v-else>
                <el-tag v-if="row.claimType == '医保外'" type="danger" hit size="small">{{ row.claimType }}</el-tag>
                <el-tag v-else-if="!!row.claimType" type="success" hit size="small">{{ row.claimType }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="left" width="160" label="嘱托" prop="content">
            <template #default="{ row }">
              <el-input v-if="isEdit(row)" type="textarea" v-model="row.content" maxlength="500" placeholder="请输入" size="small" clearable></el-input>
              <div v-else>{{ row.content }}</div>
            </template>
          </el-table-column>

          <el-table-column align="center" width="150" label="执行科室" prop="">
            <template #default="{ row }">
              <hic-dict-selector v-if="isEdit(row)" dict-type="Dept" class="f-w" v-model="row.execDeptCode" />
              <div v-else>{{ row.execDeptCode | dictText("Dept") }}</div>
            </template>
          </el-table-column>
        </hic-table>
      </el-main>
    </el-container>

    <template slot="footer">
      <el-button type="info" @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </template>
  </hic-dialog>
</template>
<script>
  import { mapGetters } from "sw-hic";
  import api from "./api";

  export default {
    props: {
      visible: Boolean,
      entity: Object,
    },
    components: {
      editorDrug: () => import("../patient/card/advice/_editorDrug"),
      editorMl: () => import("../patient/card/advice/_editorMl"),
      editorHerbal: () => import("../patient/card/advice/_editorHerbal"),
      LogDialog: () => import("../patient/card/advice/dlgLog"),
    },
    data() {
      return {
        meta: {
          loading: false,
        },
        entitie: {
          scope: "本人",
        },
        rules: {
          title: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
          scope: [{ required: true, message: "请选择模板范围", trigger: "change" }],
          keyword: [{ required: true, message: "请选输入关键字", trigger: "blur" }],
        },
        adviceEntitie: {},
      };
    },
    computed: {
      ...mapGetters(["user", "dictEnum"]),
    },
    mounted() {
      // this.entitie.scope = '本人'
    },
    methods: {
      close() {
        this.$emit("update:visible", false);
      },
      open() {
        
        console.log("传过来的==",this.entity);
        this.entitie = this.$utils.Obj.clone(this.entity)
        if(!this.entitie.scope) this.$set(this.entitie,"scope",'本人')
        if (!this.entity.items) {
          if (this.entity.details) {
            this.entity.items = JSON.parse(this.entity.details);
          } else {
            this.entity.items = [];
          }
        }

      },
      isEdit(row) {
        return row.id;
      },
      partSave(e, row, prop) {},
      adviceSave(e, row, prop) {},
      grpAddChild() {},
      save() {
        this.$refs.from.validate((valid) => {
          if (valid) {
            let _list = this.entity.items //this.$refs.adviceRef.tmpList;
            if (_list.length == 0) return this.$message.error("医嘱列表不能为空");
            this.meta.loading = true;
            this.entitie.details = JSON.stringify(_list);

            this.entitie.deptCode = this.user.deptCode;
            this.entitie.doctorCode = this.user.code;
          
            api.AdvicePackage.save(this.entitie)
              .then((res) => {
                this.meta.loading = false;
                this.$message.success("添加成功");
                this.$emit("ok");
                this.close();
              })
              .catch((err) => {
                this.meta.loading = false;
                this.$message.error(err.message || err);
              });
          }
        });
      },
      editerDrug(item) {
        this.adviceEntitie = item;
      },
      editAdvice(item) {
        this.entities.items.forEach((ele) => {
          if (ele.id == item.id) ele = item;
        });
        this.adviceEntitie = {};
      },
    },
  };
</script>
